import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Skull } from "lucide-react";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const { loginWithGoogleSession } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    window.history.replaceState(null, "", window.location.pathname);

    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }

    (async () => {
      const res = await loginWithGoogleSession(sessionId);
      if (res.ok) {
        toast.success("The dead remember you.");
        navigate("/command", { replace: true });
      } else {
        toast.error(res.error);
        navigate("/auth", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4" data-testid="auth-callback-screen">
      <Skull className="w-8 h-8 text-blood animate-pulse" />
      <p className="font-mono text-[0.7rem] tracking-[0.25em] text-muted-h">RAISING YOUR CORPSE...</p>
    </div>
  );
};

export default AuthCallback;
